
<div class="row" *ngIf="missingRolesString">
  <div class="col">
    <div class="alert alert-danger"><span>Users with the following role(s) are not assigned to this project: {{ missingRolesString }}</span></div>
  </div>
</div>